import Index from '@/pages/calls/Index'

export default {
  path: 'calls/index',
  component: Index
}